import * as model from './model'
import { GooglePairButton as View } from './view'

export const GooglePairButton = {
    model,
    View,
}
